import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { Preview } from '@mui/icons-material';
import { deletePartyInward } from '../../../Store/PHPSlice/PartyInward/PartyInwApi';
import { format_date } from '../../../Utils/Dateutils';

const TableBody = ({
    id,
    serialNumber,
    itemNm,
    dt,
    piMemo,
    totqty,
    partyNm,
    brandNm,
    totmtqty,
    sts,
    job_sts,
    selected,
    handleClick,
}) => {

    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/party-inward-edit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleViewClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/party-inward-view/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Record?");

        // If user confirms, proceed with deletion

        if (isConfirmed) {
            dispatch(deletePartyInward(id))
                .then(() => {
                    // Reload the page to show updated results
                    toast("Record Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Item:", error);
                    toast.error("Failed to delete Item");
                });
        }
    };



    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>{format_date(dt)}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', color: 'blue' }} align='center'>{piMemo}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{partyNm}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{itemNm}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{brandNm}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{totqty}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{totmtqty}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <Preview className="cursor-pointer" onClick={handleViewClick} />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${job_sts === '1' ? 'disabled-icon' : ''}`} onClick={handleEditClick} />
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${job_sts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default TableBody;
